module.exports = __webpack_public_path__ + "static/wet_center.86923035.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wet_center.png
// module id = 899
// module chunks = 169928946856436